/**
 * What a load raises when its viewer is disposed underneath it. That is a
 * normal teardown (an element removed mid-load), not a failure, so it is the
 * platform's own `AbortError` and hosts match `error.name === 'AbortError'`
 * without importing anything from here.
 *
 * Keep "trace-viewer" and "Babylon" out of the message: hosts filter unhandled
 * rejections on those names to detect engine failures.
 */
export function disposedError(): DOMException {
    return new DOMException('viewer disposed', 'AbortError');
}

export function isAbortError(error: unknown): boolean {
    return typeof error === 'object' && error !== null && (error as { name?: unknown }).name === 'AbortError';
}

/**
 * Throws {@link disposedError} once the viewer's scene is gone. Call it only
 * after a guard that has already seen `traceScene` non-null: a viewer that has
 * not booted yet has no scene either, and that is not a disposal.
 */
export function throwIfDisposed(viewer: { traceScene: object | null }): void {
    if (!viewer.traceScene) throw disposedError();
}
